import { post, put } from "./ApiService";
import Cookies from "js-cookie";

export const checkAuthentication = async () => {
    try {
        const token = Cookies.get("token");
        if (token === "11771177") return false;
        if (token) return true;
        return false;
    } catch {
        return false;
    }
};

export const createInvite = async (projectIdOrUniq, email) => {
    const response = await post("/invites", { project_id: projectIdOrUniq, email });
    return response;
};

export const acceptInvite = async (inviteToken, userId) => {
    const response = await put("/invites", { token: inviteToken, user_id: userId });
    return response;
};
